export default __webpack_public_path__ + "static/media/submenu-robot-t5.0140e2da.png";